import Accordion from './component.jsx'
export default Accordion
